'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxThehulk } from './Thehulk'
import { ThehulkProps } from './Thehulk'

interface ThehulkBlokProps {
  blok: {
    title?: ThehulkProps['title']
    subtitle?: ThehulkProps['subtitle']
    description?: SbBlokData[]
    asset?: any
    bannerContent?: any
    subBannerContent?: any
    washOpacity?: number
    cropImage?: boolean
  } & SbBlokData
}

const Thehulk: FC<ThehulkBlokProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxThehulk
        title={blok.title ? blok.title : ''}
        subtitle={blok.subtitle ? blok.subtitle : ''}
        description={
          blok.description &&
          blok.description.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        asset={
          blok.asset
            ? {
                src: blok.asset.filename,
                alt: blok.asset.alt,
                focus: blok.asset.focus,
                wash_opacity: blok.washOpacity ? blok.washOpacity : 0,
              }
            : undefined
        }
        cropImage={blok.cropImage ?? false}
        bannerContent={
          blok.bannerContent &&
          blok.bannerContent.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
        subBannerContent={
          blok.subBannerContent &&
          blok.subBannerContent.map((nestedBlok: SbBlokData) => (
            <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
          ))
        }
      />
    </div>
  )
}

export default Thehulk
